export default {
	title: 'Riscos / Aberturas',
	risks: 'Riscos',
	opportunities: 'Aberturas',
	url: 'risks',
	subtitle: '',
	all_categories: 'Filtro de categorias',
	all_impacts: 'Filtro de impacto',
	all_likelihoods: 'Filtro de probabilidade',
	all_stakeholders: 'Filtro de partes interessadas',
	all_stakes: 'Filtro de interesses',
	no_stakeholder: 'Nenhuma parte interessada',
	tabs: {
		filters: {
			title: 'Filtros de vista',

			displayed_columns: 'Colunas exibidas',
			visualization_options: 'Opções de visualização'
		},
		options: {
			title: 'Exibição',
			are_links_visible: 'Mostrar todos os vínculos',
			show_description: 'Mostrar descrição',
			chart_visible_stakes: 'Mostrar interesses',
			chart_visible_stakeholders: 'Mostrar partes interessadas',
			chart_visible_risks: 'Mostrar riscos',
			chart_visible_opportunities: 'Mostrar aberturas'
		},
		general: {
			title: 'Geral'
		},
		stakeholders: {
			title: 'Partes interessadas'
		},
		export: {
			title: 'Exportar'
		},
		comments: {
			title: 'Histórico'
		}
	},
	visualization_tab: 'Visualização',
	onboarding: {
		risks: {
			title: 'Revisão dos riscos',
			description:
				'Aqui estão os riscos que pesam sobre seus interesses. Avalie a probabilidade e o impacto e corrija aqueles que pareçam mal calibrados.'
		},
		opportunities: {
			title: 'Revisão das aberturas',
			description:
				'Ao contrário dos riscos, as aberturas são dinâmicas que podem fortalecer seus interesses. Mantenha as acionáveis, descarte o restante.'
		}
	}
};
